import { Nullable } from 'types';

export const filterTableValue = (
  value: string | number | boolean,
  field: Nullable<string>,
): boolean => {
  return Boolean(field?.toLowerCase().includes(String(value).toLowerCase()));
};
